export default {
  componentName: 'needSchemaLoaded',
  props: {
    isWatchLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: false,
      loadingToast: null,
      isWatchLoadingData: false
    };
  },
  computed: {
    customClass() {
      return this.isLoading
        ? 'rt-relation-dialog plat-standard-dialog'
        : 'rt-relation-dialog plat-standard-dialog plat-standard-loading-dialog';
    },
    isShowClass() {
      if (!this.isWatchLoadingData) return '';
      return this.isLoading ? '' : 'plat-base-loading-dialog';
    }
  },
  watch: {
    dialogVisible: function (newValue, oldValue) {
      // this.$emit('update', newValue, this.tagData);
      this.createListening(newValue);
    },
    isWatchLoading: {
      handler(newVal, oldVal) {
        this.isWatchLoadingData = newVal;
      },
      immediate: true
    }
  },
  methods: {
    schemaLoaded() {
      console.log('构建完毕');
      this.closeLoading();
      this.$nextTick(() => {
        this.isLoading = true;
      });
    },
    createListening(newValue) {
      if (!this.isWatchLoadingData && !this.isLoading) return;
      // debugger
      if (newValue) {
        // 先尝试关掉loading 在加载下一个弹窗
        rt.hideLoadingToast();
        this.closeLoading();
        this.openLoading();
        this.$on('schemaLoaded', this.schemaLoaded);
      } else {
        this.isLoading = false;
        this.closeLoading();
        this.$off('schemaLoaded', this.schemaLoaded);
      }
    },
    openLoading() {
      let options = {};
      options.text = this.$_t('main.languageLoading', '正在加载');
      options.size = 'large';
      options.textColor = 'neutralRegular';
      options.background = 'rgba(255,255,255,0)';
      options.type = 1;
      options.hiddenMask = false;
      // 增加zindex
      options.fullscreen = true;
      if (!this.loadingToast) {
        this.loadingToast = this.$loading(options);
      }
    },
    closeLoading() {
      this.loadingToast && this.loadingToast.close();
      this.loadingToast = null;
    }
  }
};



//////////////////
// WEBPACK FOOTER
// ./packages/lookup/src/dialogMixin.js
// module id = 2221
// module chunks = 228